import { render } from "./MemoryManagementModal.vue?vue&type=template&id=0f8e14e3&scoped=true"
import script from "./MemoryManagementModal.vue?vue&type=script&lang=js"
export * from "./MemoryManagementModal.vue?vue&type=script&lang=js"

import "./MemoryManagementModal.vue?vue&type=style&index=0&id=0f8e14e3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8e14e3"]])

export default __exports__